<template>
  <div>
    <b-row>
      <b-col
        align="right"
      >
        <b-button
          variant="outline-primary"
          class="mb-1"
          :disabled="loading"
          @click="fetchItems"
        >
          Refresh
        </b-button>
        <b-button
          variant="outline-primary"
          class="mb-1 ml-1"
          :disabled="deactivating || selectedBonus.length < 1"
          @click="deactivateHandler"
        >
          Deactivate
        </b-button>
        <b-button
          variant="outline-primary"
          class="mb-1 ml-2"
          @click="showBonusForm = true"
        >
          Add Special
        </b-button>
      </b-col>
    </b-row>
    <div
      v-if="loading"
      class="text-center"
    >
      <b-spinner
        label="Small Spinner"
        variant="primary"
      />
    </div>

    <b-alert
      variant="danger"
      :show="loadingError ? true : false"
    >
      <div class="alert-body">
        <p>
          {{ loadingError }}
        </p>
      </div>
    </b-alert>

    <!-- Horizontal scroll wrapper -->
    <div
      v-if="!loading && !loadingError"
      class="table-scroll-wrapper"
    >
      <b-table
        :items="results"
        :fields="tableFields"
        responsive="sm"
        striped
        hover
        :sort-by="sortBy"
        :sort-desc="sortDesc"
        class="compact-table"
        no-local-sorting
        @sort-changed="sortingChanged"
      >
        <template #head(select)>
          <b-form-checkbox
            v-model="isAllBonusSelected"
            :disabled="results.length === 0"
            @change="handleAllBonusSelectChange"
          />
        </template>
        <template #cell(select)="value">
          <b-form-checkbox
            v-model="selectedBonus"
            :value="value.item.id"
          />
        </template>
        <template #cell(batch)="data">
          {{ data.item.erp_products && data.item.erp_products.map(product => product.batch).join(', ') }}
        </template>
        <template #cell(start_date)="data">
          {{ data.item.start_date && formatedDate(data.item.start_date) }}
        </template>
        <template #cell(end_date)="data">
          {{ data.item.end_date && formatedDate(data.item.end_date) }}
        </template>
        <template #cell(status)="{item}">
          <app-chip :variant="getStausChipVariant(item.is_active)">
            {{ item.is_active ? "Active" : "Inactive" }}
          </app-chip>
        </template>
        <template #cell(action)="data">
          <feather-icon
            v-b-tooltip.hover="{boundary:'window'}"
            title="Edit Special"
            icon="Edit2Icon"
            size="20"
            class="cursor-pointer mr-1"
            @click="selectedUpdateBonusId = data.item.id"
          />
          <feather-icon
            v-b-tooltip.hover="{boundary:'window'}"
            title="View Details"
            icon="EyeIcon"
            size="20"
            class="cursor-pointer mr-1"
            @click="selectedBonusDetailId = data.item.id"
          />
        </template>
      </b-table>
    </div>

    <detailed-pagination
      v-if="!loading && !loadingError"
      :total-items="totalItems"
      :per-page="perPage"
      :current-page="currentPage"
      @page-changed="(page) => {currentPage = page}"
    />
    <add-special-bonus
      v-if="showBonusForm"
      @modal-closed="showBonusForm = false"
      @bonus-added="addBonusHandler"
    />
    <special-bonus-update-model
      v-if="selectedUpdateBonusId"
      :id="selectedUpdateBonusId"
      @modal-closed="selectedUpdateBonusId = null"
      @updated="fetchItems"
    />

    <special-bonus-details-model
      v-if="selectedBonusDetailId"
      :id="selectedBonusDetailId"
      @modal-closed="selectedBonusDetailId = null"
    />
  </div>

</template>

<script>
import {
  BSpinner, BTable, BAlert, BRow, BCol, BButton, VBTooltip,
  BFormCheckbox,
  VBPopover,
} from 'bootstrap-vue'
import axios from 'axios'
import ToastificationContent from '@/@core/components/toastification/ToastificationContent.vue'
import dateMixin from '@/mixins/dateMixin'
import formatMixin from '@/mixins/formatMixin'
import getParsedQueryString from '@/utils/headerQueryParser'
import AppChip from '@/components/UI/AppChip.vue'
import DetailedPagination from '../../UI/DetailedPagination.vue'
import AddSpecialBonus from './AddSpecialBonus.vue'
import SpecialBonusUpdateModel from './SpecialBonusUpdateModel.vue'
import SpecialBonusDetailsModel from './SpecialBonusDetailsModel.vue'

export default {
  directives: {
    'b-tooltip': VBTooltip,
    'b-popover': VBPopover,
  },
  components: {
    BSpinner,
    BTable,
    BRow,
    BCol,
    BButton,
    BAlert,
    AppChip,
    DetailedPagination,
    AddSpecialBonus,
    SpecialBonusUpdateModel,
    SpecialBonusDetailsModel,
    BFormCheckbox,
  },
  mixins: [dateMixin, formatMixin],
  props: {
    filters: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: true,
      loadingError: null,
      results: [],
      tableFields: [
        { key: 'select' },
        { key: 'product_name', label: 'Item', sortable: true },
        { key: 'batch', label: 'Batches', sortable: true },
        { key: 'start_date', label: 'Start Date', sortable: true },
        { key: 'end_date', label: 'End Date', sortable: true },
        { key: 'bonus_type', label: 'Type', sortable: true },
        { key: 'status', label: 'Status', sortable: true },
        { key: 'action', label: 'Action', sortable: true },

      ],
      selectedUpdateBonusId: null,
      selectedBonusDetailId: false,
      isAllBonusSelected: false,
      selectedBonus: [],
      currentPage: 1,
      perPage: 50,
      totalItems: 0,
      deactivating: false,
      sortBy: 'generation_date',
      sortDesc: true,
      submitting: false,
      showBonusForm: false,
    }
  },
  watch: {
    currentPage() {
      this.fetchItems()
    },
    filters() {
      if (this.currentPage !== 1) {
        this.currentPage = 1
      } else {
        this.fetchItems()
      }
    },
  },
  created() {
    this.fetchItems()
  },
  methods: {
    sortingChanged(ctx) {
      this.sortBy = ctx.sortBy
      this.sortDesc = ctx.sortDesc
      this.fetchItems()
    },

    fetchItems() {
      const params = {
        sort_by: this.sortBy,
        sort_desc: this.sortDesc,
        page: this.currentPage,
        per_page: this.perPage,
        ...this.filters,
      }
      this.loading = true
      axios.get(`/marg/special-bonus-list?${getParsedQueryString(params)}`)
        .then(res => {
          this.results = res.data.results
          this.totalItems = res.data.count
          this.loadingError = null
          this.loading = false
        }).catch(error => {
          this.loadingError = error?.response?.data?.error || error?.response?.data?.detail || 'Something went wrong'
          this.loading = false
        })
    },
    async deactivateHandler() {
      this.deactivating = true

      // Process orders one by one using reduce
      try {
        await axios.post('/marg/special-bonus/update-status/', { ids: this.selectedBonus, is_active: false })

        // Show individual success toast for each order
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Status Updated',
            text: `Total  ${this.selectedBonus.length} bonus status deactivated successfully`,
            variant: 'success',
          },
        })

        this.deactivating = false

        // Clear selected Bonuses
        this.selectedBonus = []
        this.isAllBonusSelected = false

        // Refresh the data
        this.fetchItems()
      } catch (error) {
        this.deactivating = false

        // Show error toast
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'Status Update Failed',
            text: error?.response?.data?.error || error?.response?.data?.detail || 'Something went wrong while placing orders',
            icon: 'AlertTriangleIcon',
            variant: 'danger',
          },
        })
      }
    },
    addBonusHandler() {
      this.showBonusForm = false
      this.currentPage = 1
      this.fetchItems()
    },
    editPobHandler(id) {
      this.selectedUpdateBonusId = id
    },
    getStausChipVariant(value) {
      if (value === true) {
        return 'success'
      }
      return 'danger'
    },
    handleAllBonusSelectChange(isChecked) {
      this.selectedBonus = isChecked
        ? this.results.map(data => data.id)
        : []
    },
  },
}
</script>

<style scoped>
/* Horizontal scroll wrapper */
.table-scroll-wrapper {
  overflow-x: auto;
  -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
}

/* Ensure table maintains minimum width */
.table-scroll-wrapper .table {
  min-width: 1200px; /* Adjust this value based on your needs */
  margin-bottom: 0;
}

/* Optional: Style the scrollbar */
.table-scroll-wrapper::-webkit-scrollbar {
  height: 8px;
}

.table-scroll-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
  border-radius: 4px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb {
  background: #c1c1c1;
  border-radius: 4px;
}

.table-scroll-wrapper::-webkit-scrollbar-thumb:hover {
  background: #a8a8a8;
}

/* Remove padding and margin from dropdown button and items */
.action-dropdown /deep/ .btn {
  padding: 0 !important;
  margin: 0 !important;
  border: none;
  background: transparent;
  box-shadow: none !important;
}

.action-dropdown .btn:hover,
.action-dropdown .btn:focus,
.action-dropdown .btn:active {
  background: transparent !important;
  border: none !important;
  box-shadow: none !important;
}

/* Adjust dropdown item spacing */
.action-dropdown .dropdown-item {
  padding: 0.5rem 1rem; /* Adjust vertical and horizontal spacing */
  font-size: 0.875rem;
  line-height: 1.2;
}

/* Reduce space between icon and text in dropdown items */
.action-dropdown .dropdown-item .feather {
  margin-right: 0.5rem; /* Adjust icon to text spacing */
}

/* Adjust dropdown menu positioning and spacing */
.action-dropdown .dropdown-menu {
  padding: 0.25rem 0; /* Reduce top/bottom padding of menu */
  min-width: 140px; /* Adjust menu width */
}
</style>
